import { render, staticRenderFns } from "./CashSales.vue?vue&type=template&id=4b7cae08&scoped=true&"
import script from "./CashSales.vue?vue&type=script&lang=js&"
export * from "./CashSales.vue?vue&type=script&lang=js&"
import style0 from "./CashSales.vue?vue&type=style&index=0&id=4b7cae08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7cae08",
  null
  
)

export default component.exports